module.exports = __webpack_public_path__ + "static/media/logos_squares_Gold_CHEVALIER.8298cc3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/logos_squares_Gold_CHEVALIER.png
// module id = 82
// module chunks = 0